import type { AppState } from '@store/types'

export const isActionHistoryLoading = (state: AppState) =>
  state.manager.activityHistory.isLoading

export const getActivityHistoryActions = (state: AppState) =>
  state.manager.activityHistory.actions

export const getActivityHistoryTotal = (state: AppState) =>
  state.manager.activityHistory.total

export const getActivityHistorySelectedActionId = (state: AppState) =>
  state.manager.activityHistory.selectedActionId
